import { render } from "./ReservationBadge.vue?vue&type=template&id=1d01a9f6"
import script from "./ReservationBadge.vue?vue&type=script&lang=js"
export * from "./ReservationBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__